import React, { useState } from 'react';
import {
  Fab, Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Snackbar, Tooltip,
} from '@mui/material';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { useLocation } from 'react-router-dom';
import { submitFeedback, apiErrorText } from '../api/client';

/** Floating „Was funktioniert nicht?"-Button — sichtbar für jeden eingeloggten
 *  Nutzer (auch Köche). Die Meldungen landen auf der Admin-Seite „Feedback". */
export default function FeedbackFab() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [snack, setSnack] = useState('');
  const location = useLocation();

  const send = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await submitFeedback(message.trim(), location.pathname);
      setSnack('Danke! Dein Feedback wurde gespeichert.');
      setMessage('');
      setOpen(false);
    } catch (e: any) {
      setSnack(apiErrorText(e) || 'Senden fehlgeschlagen — bitte nochmal probieren.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Tooltip title="Was funktioniert nicht?">
        <Fab
          color="primary" size="medium" onClick={() => setOpen(true)}
          sx={{ position: 'fixed', bottom: { xs: 16, md: 24 }, right: { xs: 16, md: 24 }, zIndex: 1300 }}
          aria-label="Feedback geben"
        >
          <FeedbackOutlinedIcon />
        </Fab>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Was funktioniert nicht?</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus fullWidth multiline minRows={4} sx={{ mt: 1 }}
            placeholder="Beschreibe kurz, was nicht funktioniert oder was dich stört — z. B. falscher Preis, falsche Einheit, Artikel nicht gefunden"
            value={message} onChange={(e) => setMessage(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Abbrechen</Button>
          <Button variant="contained" onClick={send} disabled={sending || !message.trim()}>
            Senden
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={!!snack} autoHideDuration={4000} onClose={() => setSnack('')} message={snack} />
    </>
  );
}
